module.exports = __webpack_public_path__ + "img/tadlace-create.cb0cdfc8.png";